export default {
  banner_text:
    "We gebruiken cookies om de app te laten werken (essentieel) en te verbeteren (analytisch). Kies wat je toelaat.",
  essential_required: "Essentieel (verplicht)",
  analytics: "Analytisch",
  marketing: "Marketing",
  allow_essential_only: "Alleen essentiële toestaan",
  save_choices: "Keuzes opslaan",
  accept_all: "Alles accepteren",
  aria_label: "Cookie-toestemming"
};
